/* Narrae ad landing pages: quick add-to-cart + sticky CTA. */
(function () {
  if (window.__narraeLp) return;
  window.__narraeLp = true;

  function toast(msg) {
    var el = document.querySelector('.nlp-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'nlp-toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-visible'); }, 2600);
  }

  function refreshCartCount(count) {
    document.querySelectorAll('.cart-count').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('visually-hidden', count === 0);
    });
  }

  // Re-render the theme's mini cart drawer and open it.
  function openDrawer() {
    if (typeof window.updateMiniCart === 'function') {
      return window.updateMiniCart(true);
    }
    return fetch(window.location.pathname + '?section_id=navigation-main')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('#mini-cart');
        var drawer = document.querySelector('#mini-cart');
        if (fresh && drawer && typeof drawer.open === 'function') {
          drawer.innerHTML = fresh.innerHTML;
          if (typeof drawer.addEventListeners === 'function') drawer.addEventListeners();
          drawer.querySelectorAll('.icon').forEach(function (i) { i.classList.add('loaded'); });
          drawer.open();
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-nlp-add]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-nlp-add');
    var label = btn.textContent;
    btn.classList.add('is-loading');
    btn.textContent = btn.getAttribute('data-loading') || 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'Could not add');
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        refreshCartCount(cart.item_count);
        return openDrawer();
      })
      .catch(function (err) { toast(err.message); })
      .finally(function () {
        btn.classList.remove('is-loading');
        btn.textContent = label;
      });
  });

  // Sticky CTA: show once the hero is scrolled past, hide while the shop grid is on screen.
  function initSticky() {
    var bar = document.querySelector('[data-nlp-sticky]');
    if (!bar || !('IntersectionObserver' in window)) return;
    var hero = document.querySelector('.nlp-hero');
    var shop = document.querySelector('.nlp-shop');
    var pastHero = !hero, shopVisible = false;
    function update() { bar.classList.toggle('is-visible', pastHero && !shopVisible); }
    if (hero) new IntersectionObserver(function (en) {
      pastHero = !en[0].isIntersecting && en[0].boundingClientRect.top < 0; update();
    }).observe(hero);
    if (shop) new IntersectionObserver(function (en) {
      shopVisible = en[0].isIntersecting; update();
    }, { threshold: 0 }).observe(shop);
  }

  // Hero video: attach sources only after the page has finished loading, then play muted.
  // Autoplay can be refused (Low Power Mode) — the poster stays, and we retry on first touch.
  function initVideos() {
    function start() {
      document.querySelectorAll('video[data-nlp-lazy-video]').forEach(function (v) {
        if (v.dataset.loaded) return;
        v.dataset.loaded = '1';
        var hls = v.querySelector('source[type="application/x-mpegURL"]');
        var mp4 = v.querySelector('source[type="video/mp4"]');
        function play() {
          v.muted = true;
          var p = v.play && v.play();
          if (p && p.catch) p.catch(function () {
            document.addEventListener('touchstart', function () { v.play().catch(function () {}); }, { once: true, passive: true });
          });
        }
        function useMp4() {
          if (hls) hls.remove();
          if (mp4) { mp4.src = mp4.getAttribute('data-src'); v.load(); play(); }
        }
        if (hls && v.canPlayType('application/vnd.apple.mpegurl')) {
          // iPhone / iPad / Instagram on iOS: native adaptive streaming.
          if (mp4) mp4.remove();
          hls.src = hls.getAttribute('data-src'); v.load(); play();
        } else if (hls && window.MediaSource) {
          // Android: small streaming player so phones get a phone-sized video, not the 1080p file.
          var sc = document.createElement('script');
          sc.src = 'https://cdn.jsdelivr.net/npm/hls.js@1.5.17/dist/hls.light.min.js';
          sc.onload = function () {
            if (!window.Hls || !window.Hls.isSupported()) return useMp4();
            var h = new window.Hls({ capLevelToPlayerSize: true, maxBufferLength: 10 });
            h.loadSource(hls.getAttribute('data-src'));
            h.attachMedia(v);
            h.on(window.Hls.Events.MANIFEST_PARSED, play);
            h.on(window.Hls.Events.ERROR, function (e, d) { if (d.fatal) { h.destroy(); useMp4(); } });
          };
          sc.onerror = useMp4;
          document.head.appendChild(sc);
        } else {
          useMp4();
        }
      });
    }
    if (document.readyState === 'complete') setTimeout(start, 300);
    else window.addEventListener('load', function () { setTimeout(start, 300); }, { once: true });
  }

  // Second "hover" photo on product cards: only fetched on devices with a mouse.
  function initHover() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    document.querySelectorAll('.nlp-card').forEach(function (card) {
      card.addEventListener('mouseenter', function () {
        var h = card.querySelector('img[data-hover-src]:not([src])');
        if (h) h.src = h.getAttribute('data-hover-src');
      }, { once: true });
    });
  }

  function init() { initSticky(); initVideos(); initHover(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
